<template>
  <div class="create-user">
    <v-btn color="primary" click="showCreate" @click="showCreate">Create</v-btn>
    <v-dialog max-width="600" v-model="modal">
      <v-card :loading="loading">
        <v-card-title>
          Create User
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="cancel" v-on="on">mdi-close</v-icon>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="userEmail"
            label="Email"
            :rules="emailFormat"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="doCreate" :disabled="!hasEmail"
            >Create</v-btn
          >
          <v-btn outlined color="secondary" @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateUser",
  data() {
    return {
      loading: false,
      modal: false,
      userEmail: "",
    };
  },
  computed: {
    hasEmail() {
      return this.userEmail.replace(/\s+/, "").length > 0;
    },
    emailFormat() {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return [(v) => pattern.test(v) || "Email format is not valid"];
    },
  },
  methods: {
    ...mapActions("users", ["createUser"]),
    showCreate() {
      this.loading = false;
      this.userEmail = "";
      this.modal = true;
    },
    cancel() {
      this.modal = false;
    },
    doCreate: async function () {
      this.loading = true;
      await this.createUser(this.userEmail);
      this.loading = false;
      this.modal = false;
    },
  },
};
</script>

<style scoped>
.create-user {
  margin-left: auto;
}
</style>
